import axios from "axios";
import { config } from "../config/config";
import { fetchAuthSession, signIn } from "aws-amplify/auth";
import { clearLocalStorage } from "./helper";
import { showToast } from "../components/Toaster/Toaster";

let refreshTokenPromise: Promise<string> | null = null;

export const refreshAccessToken = async (): Promise<string> => {
  const refreshToken = localStorage.getItem("refreshToken");

  if (!refreshToken) {
    showToast("Session expired. Please log in again.", "error");
    await new Promise(resolve => setTimeout(resolve, 1000));
    clearLocalStorage();
    throw new Error("No refresh token available");
  }

  if (!refreshTokenPromise) {
    refreshTokenPromise = axios
      .post(`${config.backendUrl}/auth/refresh-token`, { refreshToken })
      .then((response) => {
        if (!response.data?.accessToken) {
          throw new Error("No access token in response");
        }
        const newToken = response.data.accessToken;
        localStorage.setItem("accessToken", newToken);
        refreshTokenPromise = null;
        return newToken;
      })
      .catch(async (error) => {
        refreshTokenPromise = null;

        if (error.response) {
          if (
            error.response.status === 401 ||
            error.response.data?.message?.includes(
              "Invalid or expired refresh token"
            )
          ) {
            showToast("Session expired. Please log in again.", "error");
            await new Promise(resolve => setTimeout(resolve, 1000));
            clearLocalStorage();
          } else {
            showToast("Failed to refresh session. Please try again.", "error");
          }
        } else if (error.request) {
          showToast("Network error. Please check your connection.", "error");
        } else {
          showToast("An unexpected error occurred.", "error");
        }

        throw error;
      });
  }

  try {
    return await refreshTokenPromise;
  } finally {
    refreshTokenPromise = null;
  }
};

export const signInUser = async ({ username, password }: { username: string; password: string }) => {
  try {
    const response = await signIn({
      username,
      password,
    })
    console.log("Response of signInuser:", response);

    await fetchAuthSession();
  } catch (error: any) {
    console.error("Error signing in:", error);
    if (!error?.message?.toLowerCase().includes("there is already a signed in user")) {
      throw error;
    }
  }
}

export const authSession = async () => {
  try {
    const session = await fetchAuthSession();
    return session?.tokens?.accessToken?.toString();
  } catch (error) {
    console.error("Error fetching auth session:", error);
    return null;
  }
}
